import {TextButtonProps} from '../Button/TextButton';
import {IconButtonProps} from '../Button/Iconbutton';
import {MenuItemProps} from '../MenuItem/MenuItem';
import {Size} from '../types';


export type SideMenuAction = Omit<IconButtonProps, 'variant' |
  'shape' |
  'isInMobileMenu' |
  'borderRadius' |
  'flatEdge' |
  'focusBackgroundColor' |
  'useTransparentBackground' |
  'unsetIconSize' |
  'shouldNotInteract' |
  'invertFocus' |
  'hideOnLowWidth' | 'children'> & { icon: React.ReactNode };

export type  SideMenuButton =
  Omit<TextButtonProps, 'size' | 'iconOnly' | 'minWidth' | 'testId' | 'width' | 'invertFocus' | 'colorTheme' | 'flatEdge' | 'children'>
  & { label: string };

export type SideMenuItem = Omit<MenuItemProps, 'size'>

export interface SideMenuHeader {
  actions?: SideMenuAction[];
  label?: string;
}

export interface SideMenuFooter {
  items?: SideMenuItem[];
  buttons?: SideMenuButton[];
  note?: string;
}

export interface SideMenuProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: Size.Small | Size.Medium | Size.Large;
  header?: SideMenuHeader;
  footer?: SideMenuFooter;
  onClose: () => void;
  children?: any;
}
